
// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AppNav')

function AppNav(props) {
  if (props.hidden || !props.items.length) {
    return null
  }
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      props.items.map(item => (
        tag('a', {
          key: item.id,
          className: bem.element('item', {
            [item.id]: true,
            selected: props.selected === item.id
          }),
          href: item.href,
          onClick: props.onNavigate
        },
          item.title
        )
      ))
    )
  )
}

AppNav.propTypes = {
  // Values
  className: PropTypes.string,
  hidden: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,
  selected: PropTypes.string,
  // Callbacks
  onNavigate: PropTypes.func
}

module.exports = AppNav
